
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

export function AuthButtons() {
  const { t } = useTranslation();
  const location = useLocation();
  
  // Get the current path and search params
  const currentPath = location.pathname;
  const isAuthPage = currentPath === "/auth";
  const searchParams = new URLSearchParams(location.search);
  const isSignUp = searchParams.get("signup") === "true";
  
  // Determine button actions based on current location
  const renderSignInButton = () => {
    // If on auth page with signup=true, show the sign in button to toggle
    if (isAuthPage && isSignUp) {
      return (
        <Button variant="ghost" asChild>
          <Link to="/auth">{t('sign_in')}</Link>
        </Button>
      );
    }
    
    // If already on sign in page, don't show sign in button as link
    if (isAuthPage && !isSignUp) {
      return (
        <Button variant="ghost" disabled>
          {t('sign_in')}
        </Button>
      );
    }
    
    // Default case: regular sign in link
    return (
      <Button variant="ghost" asChild>
        <Link to="/auth">{t('sign_in')}</Link>
      </Button>
    );
  };
  
  const renderSignUpButton = () => {
    // If on auth page without signup=true, show the sign up button to toggle
    if (isAuthPage && !isSignUp) {
      return (
        <Button asChild>
          <Link to="/auth?signup=true">{t('sign_up')}</Link>
        </Button>
      );
    }
    
    // If already on sign up page, don't show sign up button as link
    if (isAuthPage && isSignUp) {
      return (
        <Button disabled>
          {t('sign_up')}
        </Button>
      );
    }
    
    // Default case: regular sign up link
    return (
      <Button asChild>
        <Link to="/auth?signup=true">{t('sign_up')}</Link>
      </Button>
    );
  };
  
  return (
    <div className="flex items-center gap-4">
      {renderSignInButton()}
      {renderSignUpButton()}
    </div>
  );
}
